/**
 * Renders one primary-row descriptor.
 *
 * `render: 'custom'` items (AI ▾, More ▾) own their own component, so the slot
 * just drops the supplied node in their place — that keeps them inside the
 * ordered layout for B14/B15 without the model needing to know anything about
 * their internals.
 */
import type { ReactNode } from 'react';
import { ToolbarPlainButton } from '../../../components/ui/toolbar-button';
import { resolveToolbarAction } from '../model/mainToolbarModel';
import type { ToolbarItemDescriptor } from '../model/toolbarItemTypes';

type ToolbarPrimarySlotProps = {
  item: ToolbarItemDescriptor;
  /** Node to render for a `custom` item. */
  custom?: ReactNode;
};

export function ToolbarPrimarySlot({ item, custom }: ToolbarPrimarySlotProps) {
  if (item.render === 'custom') return <>{custom ?? null}</>;

  const Icon = item.icon;
  return (
    <ToolbarPlainButton
      onClick={resolveToolbarAction(item)}
      icon={Icon ? <Icon className="h-4 w-4" /> : null}
      label={item.label}
      title={item.tooltip}
      disabled={item.disabled}
      iconOnly={item.iconOnly}
      className={item.className}
      data-testid={item.testId}
    />
  );
}
